import React from 'react';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/de';

import i18n from '../../i18n';

export default class DialogDateField extends React.Component {
    // handleDateChanged(ev) {
    //     const modifiedDate = moment(ev).format('YYYY-MM-DD');
    //     this.props.onChange(this.props.field.id, modifiedDate);
    // }
    _committedDefault = false;

    formatOut(m) {
        return moment(m).format('YYYY-MM-DD');
    }

    parseIn(v) {
        if (!v) return null;
        if (moment.isMoment(v) || v instanceof Date) {
            return moment(v);
        }
        const exact = moment(v, 'YYYY-MM-DD', true);
        if (exact.isValid()) return exact;
        // A full ISO timestamp, as records often carry: see DialogDateTimeField.
        const iso = moment(v, moment.ISO_8601, true);
        return iso.isValid() ? iso : null;
    }

    getDefaultMoment() {
        const { field } = this.props;
        if (!field || !field.default) return null;

        if (field.default === 'today') {
            return moment().startOf('day');
        }

        const asExact = moment(field.default, 'YYYY-MM-DD', true);
        if (asExact.isValid()) return asExact;

        return null;
    }

    getPickerValue() {
        const { value } = this.props;
        const parsed = this.parseIn(value);
        if (parsed) return parsed;

        const def = this.getDefaultMoment();
        return def || null;
    }

    ensureDefaultCommitted() {
        const { value, field } = this.props;

        const isEmpty =
            value === null ||
            value === undefined ||
            value === '' ||
            (moment.isMoment(value) && !value.isValid());

        if (!isEmpty) {
            this._committedDefault = false;
            return;
        }

        if (this._committedDefault) return;

        const def = this.getDefaultMoment();
        if (!def) return;

        this._committedDefault = true;
        this.props.onChange(field.id, this.formatOut(def));
    }

    componentDidMount() {
        this.ensureDefaultCommitted();
    }

    componentDidUpdate(prevProps) {
        const valueBecameEmpty =
            prevProps.value !== this.props.value &&
            (this.props.value === null ||
                this.props.value === undefined ||
                this.props.value === '');

        const defaultChanged =
            prevProps.field?.default !== this.props.field?.default;

        if (valueBecameEmpty || defaultChanged) {
            this._committedDefault = false;
            this.ensureDefaultCommitted();
        }
    }

    handleDateChanged = (ev) => {
        if (!ev) {
            this.props.onChange(this.props.field.id, null);
            return;
        }
        const formattedDate = this.formatOut(ev);
        this.props.onChange(this.props.field.id, formattedDate);
    };
    render() {
        // field, value, onChange
        const locale = i18n.language === 'en' ? 'en-gb' : i18n.language;
        let translatedName = i18n.t(`columns.${this.props.field.label}`);
        const pickerValue = this.getPickerValue();
        return (
            <LocalizationProvider
                dateAdapter={AdapterMoment}
                adapterLocale={locale}
            >
                {
                    <DatePicker
                        sx={{ width: '100%', my: 1 }}
                        id={this.props.field.id}
                        name={this.props.field.id}
                        label={translatedName}
                        value={pickerValue}
                        // A birth date opened on the current month of this year
                        // and had to be paged back decades: such a field sets
                        // openTo: 'year' and disableFuture.
                        openTo={this.props.field.openTo}
                        disableFuture={Boolean(this.props.field.disableFuture)}
                        onChange={(event) => this.handleDateChanged(event)}
                    />
                }
            </LocalizationProvider>
        );
    }
}
